import { gql } from '@apollo/client';

export const partnerConsentFragment = gql`
  fragment partnerConsent on PartnerConsent {
    id
    code
    name
    description
    templateId
    templateCode
    templateName
    requiredDocTypeId
    requiredDocTypeName
    validityDays
    isActive
    partnerTypeIds
  }
`;
